import { useState, useEffect, useCallback } from "react";
import { supabase } from "../../../lib/supabase";
import NProgress from 'nprogress';
import 'nprogress/nprogress.css';

export default function LotteryNumlotIndexSummaryContainer({ lotteryKey, title, lotteryPath, Template ,
  itemsPerPage = 100,  // 追加
  showMore = true,     // MOREボタン表示制御
  fontSize,
}) {
  const [items, setItems] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);

  const fetchLottery = useCallback(async (currentPage) => {
    NProgress.start();
    setLoading(true);
    const { data, error } = await supabase
      .schema("chatorahack")
      .rpc("get_lottery_numlot_index_summary", {
        lottery_key: lotteryKey,
        limit_count: itemsPerPage,
        offset_count: currentPage * itemsPerPage,
        sort_column: "round",
        sort_order: "DESC",
      });

    if (!error && data) {
      if (currentPage === 0) {
        setItems(data);
      } else {
        setItems((prev) => [...prev, ...data]);
      }
      if (data.length < itemsPerPage) setHasMore(false);
    }
    setLoading(false);
    NProgress.done();
  }, [lotteryKey, itemsPerPage]);  // loadingを外す

  useEffect(() => {
    fetchLottery(0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lotteryKey, itemsPerPage ]);

  const handleMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    fetchLottery(nextPage);
  };

  return (
    <Template
      items={items}
      title={title}
      lotteryKey={lotteryKey}
      lotteryPath={lotteryPath}
      hasMore={hasMore}
      loading={loading}
      onMore={handleMore}
      showMore={showMore}
      fontSize={fontSize}
    />
  );
}